const translations = {
  en: {
    login: 'login'
  }
}

export default translations
